import { Component, OnInit, AfterViewInit } from '@angular/core';
import { GRADIENT_ICONS } from 'src/app/constants/imagePath';
declare var AOS: any;
@Component({ selector: 'app-sol-connected-car', templateUrl: './connected-car.component.html', styleUrls: ['./connected-car.component.scss'], standalone: false })
export class ConnectedCarComponent implements OnInit, AfterViewInit {
  activeSection = 'overview';
  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'features', label: 'Features', icon: 'bx-star' },
    { id: 'outcomes', label: 'How It Works', icon: 'bx-cog' },
  ];
  features = [
    { icon: 'bx-car', title: 'Vehicle Health Dashboard', desc: 'Real-time engine diagnostics, fault codes, and service reminders delivered right to your smartphone.' },
    { icon: 'bx-map-alt', title: 'Trip History & Insights', desc: 'Every journey logged with distance, speed patterns, and fuel efficiency scores for smarter driving.' },
    { icon: 'bx-lock-alt', title: 'Remote Lock & Locate', desc: 'Lock, unlock, and locate your vehicle remotely from anywhere in the world via the Varroc Connect app.' },
    { icon: 'bx-bell', title: 'Smart Alerts', desc: 'Instant notifications for ignition events, boundary violations, speed alerts, and unusual vehicle activity.' },
    { icon: 'bx-wifi', title: 'Always-On Connectivity', desc: 'Vehicle stays connected via OBD dongle or embedded TCU — no phone required for data collection.' },
    { icon: 'bx-coin-stack', iconImage: GRADIENT_ICONS.MILES, title: 'Varroc Miles', desc: 'Earn loyalty points on every kilometre driven, redeemable for fuel, services, and partner rewards.' },
  ];
  ngOnInit() {}
  ngAfterViewInit() { try { AOS.refresh(); } catch (e) {} }
  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
